import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import {
  Break,
  BreakAvailableRestrictedColumns,
  BreakCodeResponse,
  BreakHistory,
  BreakNoteHandling,
  BreakResponse,
  BreakResponseObject,
  BreakSetValues,
  ExportBreaksToExcel,
  FindBreaksForm,
  UserFeatureAccess,
} from '../model/break.model'
import { BreakEmailData } from '../model/copilot.model'

@Injectable({
  providedIn: 'root',
})
export abstract class MultiBreaksService {
  abstract getBreaks(findBreaksForm: FindBreaksForm): Observable<BreakResponse>

  abstract getBreak(identifier: string): Observable<Break>

  abstract accept(
    breakIds: string[],
    note: string,
    noteHandling: BreakNoteHandling,
    restrictedBreaks?: string[],
    actionCode?: string,
    descriptionCode?: string,
    preserveExistingBreakCodes?: boolean,
  ): Observable<BreakResponseObject>

  abstract holdToDate(
    breakIds: string[],
    expirationDate: Date,
    note: string,
    noteHandling: BreakNoteHandling,
    restrictedBreaks?: string[],
    actionCode?: string,
    descriptionCode?: string,
    preserveExistingBreakCodes?: boolean,
  ): Observable<BreakResponseObject>

  abstract holdForDays(
    breakIds: string[],
    expireInBusinessDays: number,
    note: string,
    noteHandling: BreakNoteHandling,
    restrictedBreaks?: string[],
    reconDate?: Date,
    actionCode?: string,
    descriptionCode?: string,
    preserveExistingBreakCodes?: boolean,
  ): Observable<BreakResponseObject>

  abstract unresolve(breakIds: string[]): Observable<BreakResponseObject>

  abstract updateNote(
    breakIds: string[],
    note: string,
    noteHandling: BreakNoteHandling,
    actionCode?: string,
    descriptionCode?: string,
    preserveExistingBreakCodes?: boolean,
  ): Observable<BreakResponseObject>

  abstract getSetValues(): Observable<BreakSetValues>

  abstract getBreakHistory(breakId: string): Observable<BreakHistory[]>

  abstract getBreakEmailData(breakId: string): Observable<BreakEmailData>

  abstract exportBreaks(request: ExportBreaksToExcel): Observable<Blob>

  abstract getAvailableRestrictedColumns(): Observable<
    BreakAvailableRestrictedColumns[]
  >
  abstract getBreakCodes(accountIds: number[]): Observable<BreakCodeResponse>
  abstract getUserFeatureAccess(): Promise<UserFeatureAccess>
}
